import { useTranslation } from 'react-i18next';

import { Form, Field } from 'coreOld/components';
import { InputType } from 'coreOld/enums';
import { isObject } from 'coreOld/utils';
import { IRank } from 'system/types';

import { rankSchema } from './ranksFormSchema';

interface IProps {
  selectedItem?: IRank | null;
  onCloseModal?: (reset) => void;
  onSubmit?;
  onRemove?: () => void;
}

const RanksFormView = ({ selectedItem, onCloseModal, onSubmit, onRemove }: IProps) => {
  const { t } = useTranslation();

  const title = isObject(selectedItem) ? t('labelEditRank') : t('labelCreateRank');

  const btnLabel = isObject(selectedItem) ? t('buttonLabelEditRank') : t('buttonLabelCreateRank');

  return (
    <Form<IRank | string | null>
      title={title}
      submitBtnLabel={btnLabel}
      removeBtnLabel={t('buttonLabelRemoveRank')}
      onClose={onCloseModal}
      selectedItem={!isObject(selectedItem) ? null : selectedItem}
      isOpen={Boolean(selectedItem)}
      onSubmit={onSubmit}
      onRemove={onRemove}
      schema={rankSchema}
      allowRemove
    >
      <Field
        type={InputType.TEXTFIELD}
        name="rankName"
        label="Name"
        inputProps={{
          value: (selectedItem as IRank)?.rankName,
        }}
        required
      />
    </Form>
  );
};

export default RanksFormView;
